import { render, staticRenderFns } from "./batch-add.vue?vue&type=template&id=0580495a&"
import script from "./batch-add.vue?vue&type=script&lang=js&"
export * from "./batch-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports